<div
  *ngIf="operation$ | async as operation"
  class="w-full flex items-start space-x-[4rem] -mt-[9.8rem] p-4"
>
  <div class="w-[600px] flex items-start space-x-8 divide-x -mt-2">
    <div [routerLink]="['/projets']" class="text-lg cursor-pointer">
      <span class="text-lg tracking-wider">{{
        operationTitle | carLimitation : 50
      }}</span>
    </div>
    <div
      [routerLink]="['/projet', operation.id]"
      class="text-lg font-bold tracking-wider cursor-pointer pl-4"
    >
      <span class="break-keep">{{
        operation?.denomination | uppercase | carLimitation : 50
      }}</span>
    </div>
    <div
      *ngIf="childtitle$ | async as activeroutetitle"
      class="w-2/4 text-sm whitespace-nowrap tracking-wider pl-4 pt-1"
    >
      {{ activeroutetitle }}
    </div>
  </div>
  <div class="w-80 space-x-4 flex items-start">
    <div class="w-4/12 flex items-end">
      <label
        for="operation-new-actions-modal"
        class="btn btn-sm btn-primary -mt-2"
        >Nouveau</label
      >
      <input
        type="checkbox"
        id="operation-new-actions-modal"
        class="modal-toggle"
      />
      <div class="modal">
        <div class="modal-box">
          <app-button-action-new [items]="[1, 2, 3]"></app-button-action-new>
          <div class="modal-action">
            <label for="operation-new-actions-modal" class="btn">Annuler</label>
          </div>
        </div>
      </div>
    </div>
    <div class="w-6/12 flex items-end justify-center gap-2">
      <!-- project notes -->
      <app-button-menu
        [menu]="btnMenus"
        (select)="onSelectAction($event, operation)"
      ></app-button-menu>
      <!-- <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Notes"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'suivis']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Documents"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'documents']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Tâches"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'tasks']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Participants"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'participants']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Entreprises"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'entites']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
          />
        </svg>
      </button>
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Marchés"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'modules']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
          />
        </svg>
      </button>
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Lots"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'actions']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Contrats"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'missions']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
          />
        </svg>
      </button>
  
      <button
        *ngIf="operation"
        nz-tooltip
        [nzTooltipMouseEnterDelay]="0.5"
        nzTooltipPlacement="bottom"
        nzTooltipTitle="Fiches de poste"
        nzPopconfirmPlacement="bottom"
        [routerLink]="['/projet', operation.id, 'fichesDePoste']"
        class="group/button btn-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 28 28"
          stroke-width="1.5"
          stroke="currentColor"
          class="iconSvg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
          />
        </svg>
      </button>
   -->
      <div>
        <button
          *ngIf="operation"
          nz-tooltip
          [nzTooltipMouseEnterDelay]="0.5"
          nzTooltipPlacement="bottom"
          nzTooltipTitle="Paramètres"
          nzPopconfirmPlacement="bottom"
          [routerLink]="['/projet', operation.id, 'parametres']"
          class="btn btn-circle btn-ghost"
        >
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="h-6 w-6"
          >
            <title>Paramètres</title>
            <g
              id="页面-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g id="System" transform="translate(-1248.000000, 0.000000)">
                <g
                  id="settings_3_line"
                  transform="translate(1248.000000, 0.000000)"
                >
                  <path
                    d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                    id="MingCute"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M14.0352,2.80881 C14.4041,2.54328 14.9244,2.41911 15.4361,2.60633 C16.5334,3.00779 17.5399,3.59556 18.4176,4.33073 C18.8347,4.6801 18.9873,5.19202 18.942,5.64392 C18.8666,6.39677 18.9994,7.12366 19.3611,7.7502 C19.6827889,8.30737333 20.1637667,8.74748988 20.7513584,9.05690332 L20.9766,9.16678 C21.3914,9.35374 21.7593,9.74288 21.8525,10.2803 C21.9495,10.8397 22,11.4144 22,12.0001 C22,12.5858 21.9495,13.1606 21.8525,13.72 C21.76862,14.20366 21.462233,14.567197 21.0994052,14.7713908 L20.9766,14.8335 C20.2865,15.1446 19.723,15.6233 19.3611,16.2501 C18.9994,16.8766 18.8666,17.6034 18.942,18.3562 C18.9872,18.8081 18.8347,19.32 18.4176,19.6694 C17.5399,20.4045 16.5334,20.9923 15.4362,21.3937 C14.9245,21.581 14.4042,21.4568 14.0353,21.1912 C13.4206,20.7488 12.7241,20.5 12,20.5 C11.2759,20.5 10.5794,20.7488 9.96474,21.1912 C9.59585,21.4568 9.07552,21.581 8.56378,21.3937 C7.46655,20.9923 6.46002,20.4045 5.5823,19.6693 C5.16523,19.32 5.01269,18.8081 5.05794,18.3562 C5.13332,17.6034 5.00045,16.8766 4.63874,16.2501 C4.31706,15.6929444 3.83615432,15.2528062 3.24858549,14.9433807 L3.02335,14.8335 C2.6086,14.6465 2.24075,14.2574 2.14752,13.72 C2.05047,13.1606 2,12.5858 2,12.0001 C2,11.4143 2.05047,10.8396 2.14751,10.2801 C2.231417,9.796467 2.5377662,9.4329165 2.90054972,9.2287416 L3.02334,9.16664 C3.71344,8.85555 4.27685,8.37689 4.63874,7.75007 C5.00046,7.12356 5.13333,6.39671 5.05794,5.64391 C5.01268,5.19203 5.16522,4.68015 5.5823,4.3308 C6.46004,3.59559 7.4666,3.0078 8.56387,2.60633 C9.07558,2.4191 9.59589,2.54328 9.96478,2.80881 C10.5794,3.25123 11.2759,3.50003 12,3.50003 C12.7241,3.50003 13.4206,3.25123 14.0352,2.80881 Z M14.9917,4.57792 C14.1261,5.14715 13.1053,5.50003 12,5.50003 C10.8947,5.50003 9.87388,5.14715 9.00832,4.57792 C8.30727,4.8608 7.65502,5.24042 7.0682,5.70056 C7.12793,6.734 6.92299,7.79365 6.37079,8.75007 C5.81845,9.70677 5.00295,10.4142 4.07778,10.8792 C4.02655,11.245 4,11.6192 4,12.0001 C4,12.381 4.02655,12.7551 4.07778,13.121 C5.00295,13.586 5.81845,14.2934 6.37079,15.2501 C6.92298,16.2065 7.12793,17.2661 7.0682,18.2995 C7.655,18.7597 8.30722,19.1393 9.00824,19.4222 C9.87381,18.8529 10.8947,18.5 12,18.5 C13.1053,18.5 14.1262,18.8529 14.9918,19.4222 C15.6927,19.1393 16.3449,18.7597 16.9317,18.2996 C16.872,17.2662 17.0769,16.2065 17.6291,15.2501 C18.1815,14.2933 18.997,13.5859 19.9222,13.1209 C19.9735,12.7551 20,12.381 20,12.0001 C20,11.6192 19.9735,11.2451 19.9222,10.8794 C18.997,10.4144 18.1815,9.70693 17.6291,8.7502 C17.0769,7.79371 16.8719,6.734 16.9317,5.7005 C16.3449,5.24039 15.6927,4.86079 14.9917,4.57792 Z M12,8 C14.2091,8 16,9.79086 16,12 C16,14.2091 14.2091,16 12,16 C9.79086,16 8,14.2091 8,12 C8,9.79086 9.79086,8 12,8 Z M12,10 C10.8954,10 10,10.8954 10,12 C10,13.1046 10.8954,14 12,14 C13.1046,14 14,13.1046 14,12 C14,10.8954 13.1046,10 12,10 Z"
                    id="形状"
                    fill="#09244BFF"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </button>

        <button
          nz-dropdown
          [nzDropdownMenu]="operationHeaderActions"
          nzPlacement="bottomCenter"
          nzPopconfirmPlacement="bottom"
          nzTrigger="click"
          class="btn btn-circle btn-ghost"
        >
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="h-6 w-6"
          >
            <title>Navigation</title>
            <g
              id="页面-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="System"
                transform="translate(-144.000000, -288.000000)"
                fill-rule="nonzero"
              >
                <g
                  id="more_2_line"
                  transform="translate(144.000000, 288.000000)"
                >
                  <path
                    d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                    id="MingCute"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M12,16.5 C12.8284,16.5 13.5,17.1716 13.5,18 C13.5,18.8284 12.8284,19.5 12,19.5 C11.1716,19.5 10.5,18.8284 10.5,18 C10.5,17.1716 11.1716,16.5 12,16.5 Z M12,10.5 C12.8284,10.5 13.5,11.1716 13.5,12 C13.5,12.8284 12.8284,13.5 12,13.5 C11.1716,13.5 10.5,12.8284 10.5,12 C10.5,11.1716 11.1716,10.5 12,10.5 Z M12,4.5 C12.8284,4.5 13.5,5.17157 13.5,6 C13.5,6.82843 12.8284,7.5 12,7.5 C11.1716,7.5 10.5,6.82843 10.5,6 C10.5,5.17157 11.1716,4.5 12,4.5 Z"
                    id="形状"
                    fill="#09244BFF"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <nz-dropdown-menu #operationHeaderActions="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="onSelectAction('download', operation)">
        <nz-row nzAlign="middle" nzGutter="0" nzJustify="start">
          <nz-col nzSpan="4"><mat-icon>download</mat-icon></nz-col>
          <nz-col nzSpan="4" class="divider"></nz-col>
          <nz-col nzSpan="16">Télécharger</nz-col>
        </nz-row>
      </li>
      <li nz-menu-item (click)="onSelectAction('share', operation)">
        <nz-row nzAlign="middle" nzGutter="0" nzJustify="start">
          <nz-col nzSpan="4"><mat-icon>share</mat-icon></nz-col>
          <nz-col nzSpan="4" class="divider"></nz-col>
          <nz-col nzSpan="16">Partager</nz-col>
        </nz-row>
      </li>

      <li nz-menu-divider></li>

      <li
        nz-menu-item
        nzDanger
        nz-popconfirm
        [nzPopconfirmTitle]="'Supprimer ce projet ?'"
        nzPopconfirmPlacement="bottom"
        nz-popconfirm
        (nzOnConfirm)="onDelete(operation)"
        (nzOnCancel)="onCancel()"
      >
        <nz-row nzAlign="middle" nzGutter="4" nzJustify="start">
          <nz-col nzSpan="4"><i nz-icon nzType="delete"></i></nz-col>
          <nz-col nzSpan="4" class="divider"></nz-col>
          <nz-col nzSpan="16">Supprimer</nz-col>
        </nz-row>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
